import { getController, apiService as Service } from '@/services/service'
import type { AxiosProgressEvent } from 'axios'

const url = 'documents'

export const documentService = {
	...getController<
		Api.DocumentResource,
		Api.DocumentPostInput,
		Api.DocumentUpdateInput
	>(url),
	binary: <T>(
		id: number,
		responseType: Api.ResponseType,
		endpoint?: string,
		onDownloadProgress?: (e: AxiosProgressEvent) => void,
		signal?: AbortSignal
	) =>
		Service.get<T>({
			url: `${endpoint ?? url}/${id}/binary`,
			responseType,
			onDownloadProgress,
			signal,
		}),
	// Thumbnails are decorative and Thumbnail.vue already renders a placeholder on
	// failure, so a page preview that does not load must never pop the global error
	// dialog or redirect the user away.
	thumbnail: (id: number, page: number) =>
		Service.get({
			url: `${url}/${id}/thumbnail/${page}`,
			responseType: 'arraybuffer',
			meta: { silentError: true },
		}),
}

export default documentService
